import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  navigationButton: {
    marginRight: theme.spacing(2),
  },
  content: {
    flexDirection: 'column',
    flexGrow: 1,
  },
  title: {
    fontWeight: 500,
  },
}));

export default useStyles;
